import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export type CookieConsentStatus = 'unset' | 'accepted' | 'declined';

type CookieConsentState = {
  status: CookieConsentStatus;
  accept: () => void;
  decline: () => void;
};

export const useCookieConsentStore = create<CookieConsentState>()(
  persist(
    (set) => ({
      status: 'unset',
      accept: () => set({ status: 'accepted' }),
      decline: () => set({ status: 'declined' }),
    }),
    {
      name: 'landcorp-cookie-consent',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ status: state.status }),
      skipHydration: true,
    },
  ),
);

/** Sync `cookieConsent=true` document cookie into the store after persist rehydration. */
export function applyLegacyCookieConsentFromDocument(): void {
  try {
    if (
      useCookieConsentStore.getState().status === 'unset' &&
      typeof document !== 'undefined' &&
      document.cookie.includes('cookieConsent=true')
    ) {
      useCookieConsentStore.getState().accept();
    }
  } catch (error) {
    console.warn('Cookie consent hydrate error:', error);
  }
}
